/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getWorkFlowSteps } from 'app/entities/work-flow-step/work-flow-step.reducer';
import { getEntities as getWorkFlowProtocolLogs } from 'app/entities/work-flow-protocol-log/work-flow-protocol-log.reducer';
import { createEntity, getEntity, reset, updateEntity } from './work-flow-step-log.reducer';

export const WorkFlowStepLogUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const workFlowSteps = useAppSelector(state => state.workFlowStep.entities);
  const workFlowProtocolLogs = useAppSelector(state => state.workFlowProtocolLog.entities);
  const workFlowStepLogEntity = useAppSelector(state => state.workFlowStepLog.entity);
  const loading = useAppSelector(state => state.workFlowStepLog.loading);
  const updating = useAppSelector(state => state.workFlowStepLog.updating);
  const updateSuccess = useAppSelector(state => state.workFlowStepLog.updateSuccess);

  const handleClose = () => {
    navigate(`/work-flow-step-log${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaries({}));
    dispatch(getWorkFlowSteps({}));
    dispatch(getWorkFlowProtocolLogs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...workFlowStepLogEntity,
      ...values,
      completedByType: clinicalDictionaries.find(it => it.id.toString() === values.completedByType?.toString()),
      step: workFlowSteps.find(it => it.id.toString() === values.step?.toString()),
      protocol: workFlowProtocolLogs.find(it => it.id.toString() === values.protocol?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...workFlowStepLogEntity,
          completedByType: workFlowStepLogEntity?.completedByType?.id,
          step: workFlowStepLogEntity?.step?.id,
          protocol: workFlowStepLogEntity?.protocol?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.workFlowStepLog.home.createOrEditLabel" data-cy="WorkFlowStepLogCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.workFlowStepLog.home.createOrEditLabel">Create or edit a WorkFlowStepLog</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="work-flow-step-log-id"
                  label={translate('tinyMedicRestApp.workFlowStepLog.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowStepLog.value')}
                id="work-flow-step-log-value"
                name="value"
                data-cy="value"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="valueLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.value" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowStepLog.notes')}
                id="work-flow-step-log-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <UncontrolledTooltip target="notesLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.notes" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowStepLog.completedById')}
                id="work-flow-step-log-completedById"
                name="completedById"
                data-cy="completedById"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="completedByIdLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.completedById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowStepLog.active')}
                id="work-flow-step-log-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowStepLog.cursor')}
                id="work-flow-step-log-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowStepLog.lastUpdated')}
                id="work-flow-step-log-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowStepLog.microSec')}
                id="work-flow-step-log-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowStepLog.timestampEntry')}
                id="work-flow-step-log-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowStepLog.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="work-flow-step-log-completedByType"
                name="completedByType"
                data-cy="completedByType"
                label={translate('tinyMedicRestApp.workFlowStepLog.completedByType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="work-flow-step-log-step"
                name="step"
                data-cy="step"
                label={translate('tinyMedicRestApp.workFlowStepLog.step')}
                type="select"
              >
                <option value="" key="0" />
                {workFlowSteps
                  ? workFlowSteps.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="work-flow-step-log-protocol"
                name="protocol"
                data-cy="protocol"
                label={translate('tinyMedicRestApp.workFlowStepLog.protocol')}
                type="select"
              >
                <option value="" key="0" />
                {workFlowProtocolLogs
                  ? workFlowProtocolLogs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/work-flow-step-log" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default WorkFlowStepLogUpdate;
